import styled from 'styled-components'

const OfflineOffer = styled.span`
  font-size: small;
  padding: 8px;
`

export { OfflineOffer }
